import { SearchUsersPage } from '@repo/ccc-main-app-lib/src/pages/SearchUsersPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export type SearchUserPageSearchParams = {
  q?: string
}

export const Route = createFileRoute('/_authenticated/')({
  component: SearchUsersPageContainer,
  validateSearch: (search): SearchUserPageSearchParams => {
    return { q: search.q as string }
  },
})

function SearchUsersPageContainer() {
  const { q } = Route.useSearch()

  return <SearchUsersPage defaultKeyword={q} />
}
